import { render, staticRenderFns } from "./ClassroomDetailTabMyTaskLibraryDetail.vue?vue&type=template&id=088ef34c&scoped=true"
import script from "./ClassroomDetailTabMyTaskLibraryDetail.vue?vue&type=script&lang=js"
export * from "./ClassroomDetailTabMyTaskLibraryDetail.vue?vue&type=script&lang=js"
import style0 from "./ClassroomDetailTabMyTaskLibraryDetail.vue?vue&type=style&index=0&id=088ef34c&prod&lang=stylus&scoped=true"
import style1 from "./ClassroomDetailTabMyTaskLibraryDetail.vue?vue&type=style&index=1&id=088ef34c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ef34c",
  null
  
)

export default component.exports